import { render, staticRenderFns } from "./VQBKQMMS.vue?vue&type=template&id=37d7c808&scoped=true"
import script from "./VQBKQMMS.vue?vue&type=script&lang=js"
export * from "./VQBKQMMS.vue?vue&type=script&lang=js"
import style0 from "./VQBKQMMS.vue?vue&type=style&index=0&id=37d7c808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7c808",
  null
  
)

export default component.exports